module.exports = "/packs/004-b1514f481f74c0366bb9c8a041ab175c.jpg";